import { Platform } from "@-/com.npmjs.react-native";
import {
  isJiebaReady as rnIsJiebaReady,
  prepareJieba as rnPrepareJieba,
  type PrepareJiebaOptions,
} from "react-native-jieba";

// Mirrored to `apps/haniverse-expo/public/jieba-wasm/` by the web prebuild step so
// Metro/Expo can serve the wasm binary at a stable URL (see web-prebuild.ts).
const JIEBA_WASM_PUBLIC_URL = "/jieba-wasm/jieba_rs_wasm_bg.wasm";

let ensurePromise: Promise<void> | undefined;

function prepare(options: PrepareJiebaOptions = {}): Promise<void> {
  if (Platform.OS === "web") {
    return rnPrepareJieba({
      ...options,
      wasmUrl: options.wasmUrl ?? JIEBA_WASM_PUBLIC_URL,
    });
  }
  return rnPrepareJieba(options);
}

/** Lazily warm up jieba (web wasm load, Android dict extraction). Idempotent. */
export function ensureJiebaReady(): Promise<void> {
  if (rnIsJiebaReady()) {
    return Promise.resolve();
  }
  if (ensurePromise === undefined) {
    ensurePromise = prepare().catch((error: unknown) => {
      ensurePromise = undefined;
      throw error;
    });
  }
  return ensurePromise;
}

/** Start loading jieba as early as possible without awaiting. */
export function warmJieba(): void {
  void ensureJiebaReady();
}
